module.exports = __webpack_public_path__ + "static/media/20-years.991813d2.png";